"use client";

import { openDiscovery } from "./open-discovery";

/** ProfileStickyCta watches this button to take over once it scrolls away. */
export const HERO_CTA_ID = "profile-hero-cta";

/**
 * Phone and tablet button right under the therapist's name, so the free intro
 * is on the first screen. Below `lg` the prices and the main booking buttons
 * come after the whole header, under the fold; without this, a visitor from an
 * ad saw a photo, a name and a quote and nothing to tap.
 */
export default function ProfileHeroCta({
  firstName,
  discovery,
}: {
  firstName: string | null;
  /** "slots": intro with a time picker; "contact": intro by contact request. */
  discovery: "slots" | "contact";
}) {
  const name = firstName ?? "terapeutul";

  return (
    <button
      id={HERO_CTA_ID}
      type="button"
      onClick={() => openDiscovery("profile_hero_cta")}
      className="mt-5 flex w-full max-w-md flex-col items-center justify-center gap-0.5 rounded-lg bg-[#DC7050] px-5 py-3.5 text-[15px] font-semibold text-white shadow-[0_4px_16px_rgba(220,112,80,0.30)] transition-colors hover:bg-[#c25c3e] active:scale-[0.98] lg:hidden"
    >
      <span>{discovery === "slots" ? "Programează ședința de cunoaștere →" : "Cere o ședință de cunoaștere →"}</span>
      <span className="text-[12px] font-normal text-white/85">
        {discovery === "slots" ? `cu ${name} · gratuit, online` : "gratuit · 20 de minute · online"}
      </span>
    </button>
  );
}
